module.exports = __webpack_public_path__ + "static/pic06.8737f8d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic06.jpg
// module id = 532
// module chunks = 35783957827783